module.exports = __webpack_public_path__ + "static/connectiq-app-c797764a0f0dc3e95b517f0f9e2a9be2.png";